export { default } from '@/features/purchasesStatistics/ducks/dao';
